import { Box } from '@mui/material';
import React, { useRef } from 'react';
import BaseVideo from 'components/video/BaseVideo';
import { useMediaQuery } from '@mui/system';
import appTheme from 'ui-blocks/AppTheme';
import { clothingSectionStyles } from '../clothingSectionStyles';

const baseUrl = `${process.env.REACT_APP_S3_BASE_URL}/29_april_revamp/fashion`;

const videoSources = [
	{
		id: 'fashion_video_1',
		src: `${baseUrl}/fashion_video_1.mp4`,
		thumbnail: `${baseUrl}/thumbnail_fashion_video_1.webp`,
	},
	{
		id: 'fashion_video_2',
		src: `${baseUrl}/fashion_video_2.mp4`,
		thumbnail: `${baseUrl}/thumbnail_fashion_video_2.webp`,
	},
	{
		id: 'fashion_video_3',
		src: `${baseUrl}/fashion_video_3.mp4`,
		thumbnail: `${baseUrl}/thumbnail_fashion_video_3.webp`,
	},
];

export default function CharactersClothingVideos() {
	const isMobile = useMediaQuery(appTheme.breakpoints.down('smTab'));
	const isTablet = useMediaQuery(appTheme.breakpoints.down('mobileUi'));
	const videoRefs = videoSources.map(() => useRef(null));

	const secondVideoIndex = 1;

	const handleMouseEnter = (index) => {
		videoRefs.forEach((ref) => {
			ref?.current?.handleVideoPause();
		});
		videoRefs[index]?.current?.handleVideoPlay();
	};

	const handleMouseLeave = (index) => {
		videoRefs[index]?.current?.handleVideoPause();
		videoRefs[secondVideoIndex]?.current?.handleVideoPlay();
	};
	return (
		<Box id="characters-clothing-video-container" sx={[clothingSectionStyles.videoContainer]}>
			{videoSources.map((video, index) => (
				<Box
					key={`character-clothing-${video.id}`}
					sx={{
						flex: index === 1 ? 1.17 : 1,
					}}
					id={`character-clothing-${index + 1}`}
					onMouseEnter={() => handleMouseEnter(index)}
					onMouseLeave={() => handleMouseLeave(index)}
				>
					<BaseVideo
						ref={videoRefs[index]}
						id={`hero-video-${index}`}
						src={video.src}
						poster={video.thumbnail}
						controls={false}
						autoPlay={isTablet || index === secondVideoIndex}
						muted
						loop
						playPauseIcon={false}
						showSkeletonLoading
						playsInline
						style={{
							...clothingSectionStyles.baseVideo,
							borderRadius: isMobile ? '16px' : '32px',
						}}
						containerStyle={{
							aspectRatio: '0.5',
						}}
					/>
				</Box>
			))}
		</Box>
	);
}
